// extracted by mini-css-extract-plugin
export default {"committeeNav":"committee-nav_committeeNav__SEhpe","smallIcon":"committee-nav_smallIcon__pmm0+"};